
const getPalmaVariations = (commonCanopies, commonVariaton) => {
    return {
        '3720': {
            ...commonVariaton,
            size: {
                width: 0.026,
                height: 1,
                depth: 0.026
            },
            paddingTop: -1,
            familyName: 'palma',
            related: ['3720'],
            canopy: {
                ...commonCanopies,
                "10": {
                    ...commonCanopies['10'],
                    source: '/models/canopy_palma.glb',
                    size: {
                        width: 0.25,
                        depth: 0.25,
                        height: 0.03
                    },
                }
            },
            light: {
                type: 'spot',
                power: 199,
                options: { angle: Math.PI / 8 }
            }
        }
    }
}

export default getPalmaVariations